import React from 'react';

const ConciliacaoConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/conciliacao',
      component: React.lazy(() => import('./Conciliacao')),
    },
  ],
};

export default ConciliacaoConfig;
